<template>
    <div>
<!--        {{IDLABSelected}}-->

<!--        <hr>-->
<!--        {{dataPCRSpecLN}}-->
<!--        <hr>-->

        <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <p class="is-size-5"> Status  </p>
                </div>
                <div class="level-item">
                    <p v-if="dataPCRSpecLN.status.id < 5 "  class="is-size-5 has-text-info"> &nbsp; {{ dataPCRSpecLN.status.name }}  </p>
                    <p v-if="dataPCRSpecLN.status.id >=5 && dataPCRSpecLN.status.id <=6"  class="is-size-5 has-text-success"> &nbsp; {{ dataPCRSpecLN.status.name }}  </p>
                    <p v-if="dataPCRSpecLN.status.id === 7 "  class="is-size-5 has-text-danger"> &nbsp; {{ dataPCRSpecLN.status.name }} </p>
                </div>
                <div class="level-item">
                    <b-icon icon="lock" type="is-danger"  v-if="dataPCRSpecLN.status.id >=5 "  ></b-icon>
                    <b-icon icon="lock-open" type="is-success"  v-if="dataPCRSpecLN.status.id < 5 "  ></b-icon>
                </div>
                <div class="level-item">
                    <p class="is-size-5"> Assigned for </p>
                </div>
                <div class="level-item">
                    <p class="is-size-5 has-text-grey"> &nbsp; {{ dataPCRSpecLN.assigned_to_user.name }}</p>
                </div>
                <div class="level-item">

                    <b-button type="is-success"
                              id="button_edit"
                              icon-left="pencil"
                              @click="showEditPCR"
                              :disabled="!IDLABSelected.idlab "
                              v-if="
                                (
                                 (  ( dataPCRSpecLN && (userRoleFind(3) || userRoleFind(4)  ))     )
                                 ||
                                    ( dataPCRSpecLN && userIsAdmin )
                                 ||
                                  ( dataPCRSpecLN && dataPCRSpecLN.assigned_to_user.id === user_id )
                                 )  && dataPCRSpecLN.status.id <=5

                                 ">
                        Edit
                    </b-button>

                </div>
                <div class="level-item">
                    <b-button type="is-primary  is-light" icon-left="file-pdf-box" :disabled="loadingReportFile" v-if="dataPCRSpecLN.status.id >=5 && userRoleFind(6)" :loading="loadingReportFile"     @click="reqReportFile(false,-1,[])">View as Pdf(Text)</b-button>
                </div>
                <div class="level-item">
                    <b-button type="is-primary  is-light" icon-left="file-pdf-box"  v-if="dataPCRSpecLN.status.id >=5 && userRoleFind(6)" :disabled="!dataPCRSpecLN.display_title_image_for_nonadmin ||loadingImgReportFile "  :loading="loadingImgReportFile"  @click="reqImageReportFile">View as Pdf(Images)</b-button>
                </div>

            </div>
            <div class="level-right" v-if="( (dataPCRSpecLN.assigned_to_user.id === user_id )||(userIsAdmin) )&& ( dataPCRSpecLN.status.id >= 5 &&dataPCRSpecLN.status.id <= 6)">
                <div class="level-item">
                    <b-button type="is-danger"
                              icon-left="plus"
                              class="btn_plus"
                              @click="plusSomething">Plus
                    </b-button>
                </div>
                <div class="level-item">
                    <b-field
                            :type="{ 'is-danger': hasErrorPlusSomethingSelected}"
                            :message="{ 'pls select  ': hasErrorPlusSomethingSelected}">
                        <b-select placeholder="Select Plus Type" v-model="plusSomethingSelected">
                            <option value = 0> {{headerInfoPrepare}} </option>
                            <option value = 1> {{findingAndContent}} </option>
                            <option value = 2> {{images_title}} </option>
                            <option value = 3> {{ClassificationOfDiseases}} </option>
                            <option value = 4> {{PathogenSelect}} </option>
                        </b-select>
                    </b-field>
                </div>
            </div>
        </nav>
        <hr>




        <div v-if="dataPCRSpecLN && dataPCRSpecLN.status.id >= 5 && dataPCRSpecLN.status.id <=6 ">


            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!-- Display Title if normal or plus existing  -->
<!--            <div class="container" v-if="dataPCRSpecLN.display_title_prepare_for_nonadmin ">-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="headerPrepareInfo"-->
<!--                           :plus=false-->
<!--                           :showIcon = true-->
<!--                           :showDatUserWhoView = "false"-->
<!--                           :showTitleDisplay = true-->
<!--                           :iconToShow = "iconFileDocument"-->
<!--                           :visible = "true"/>-->
<!--            </div>-->
            <div class="container" v-if=" displayTitle( dataPCRSpecLN.dat_prepare.dat_txt ,dataPCRSpecLN.data_plus.dat_prepare , dataPCRSpecLN.display_title_prepare_for_nonadmin)   ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="headerPrepareInfo"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconFileDocument"
                           :visible = "true"/>
            </div>
            <!----------------------  Prepared   disPlayOrNot   dataPCRSpecLN && dataPCRSpecLN.dat_prepare.dat_txt.length>0  ------>
            <div class="container"  v-if="disPlayOrNot(dataPCRSpecLN ,dataPCRSpecLN.dat_prepare.dat_txt.length ,dataPCRSpecLN.dat_prepare.visible )" >
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="headerPrepareInfo"
                           :plus=false
                           :showIcon = false
                           :showTitleDisplay = false
                           :visible = " dataPCRSpecLN.dat_prepare.visible "/>
                <div class="box"  >
                    <div  v-html="getDecodeFromBase64ToHtml( dataPCRSpecLN.dat_prepare.dat )"
                          :style= "getStyleVisibleFalseInContent(dataPCRSpecLN.dat_prepare.visible)" >
                    </div>
                </div>

                <FooterPlus  :user_rec="dataPCRSpecLN.dat_prepare.user_rec"
                             :date_rec="dataPCRSpecLN.dat_prepare.date_rec"
                             :time_rec="dataPCRSpecLN.dat_prepare.time_rec"
                             :user_delete="dataPCRSpecLN.dat_prepare.user_edit"
                             :date_delete="dataPCRSpecLN.dat_prepare.date_edit"
                             :time_delete="dataPCRSpecLN.dat_prepare.time_edit"
                             :userIsAdmin="userIsAdmin"
                             :idToDelete = "dataPCRSpecLN.dat_prepare.id.toString()"
                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare"
                             :labKind = "IDLABSelected.kind"
                             :canDelete ="dataPCRSpecLN.dat_prepare.visible"
                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
            </div>


            <!----------------------- Prepare Plus  dataPCRSpecLN && dataPCRSpecLN.data_plus.dat_prepare.length>0 -->
            <div v-for="dat_prepare_plus in  dataPCRSpecLN.data_plus.dat_prepare" :key="dat_prepare_plus.id">
                <div  class="container" v-if="disPlayOrNot(true,true,dat_prepare_plus.visible)">
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="headerPrepareInfoPlus"
                               :plus=true
                               :showIcon = false
                               :showTitleDisplay = false
                               :visible = " dat_prepare_plus.visible "
                    />
                    <div class="box"  >
                        <div v-html="getDecodeFromBase64ToHtml(dat_prepare_plus.dat)"  :style= "getStyleVisibleFalseInContent(dat_prepare_plus.visible)"
                        >
                        </div>
                    </div>
                    <FooterPlus  :user_rec="dat_prepare_plus.user_rec"
                                 :date_rec="dat_prepare_plus.date_rec"
                                 :time_rec="dat_prepare_plus.time_rec"
                                 :user_delete="dat_prepare_plus.user_edit"
                                 :date_delete="dat_prepare_plus.date_edit"
                                 :time_delete="dat_prepare_plus.time_edit"
                                 :canDelete ="dat_prepare_plus.visible"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "dat_prepare_plus.id.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"
                    />
                </div>
            </div>











<!--            <div class="container" v-if="dataPCRSpecLN.display_title_data_pathogen_for_nonadmin ">-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="PathogenSelect"-->
<!--                           :plus=false-->
<!--                           :showIcon = true-->
<!--                           :showDatUserWhoView = "false"-->
<!--                           :showTitleDisplay = true-->
<!--                           :iconToShow = "iconPcr"-->
<!--                           :visible = "true"/>-->


<!--            </div>-->

            <div class="container" v-if=" displayTitle(  dataPCRSpecLN.dataresultset_2 ,  dataPCRSpecLN.data_plus.dataresultset_2 , dataPCRSpecLN.display_title_data_pathogen_for_nonadmin  )   ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="PathogenSelect"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconPcr"
                           :visible = "true"/>
            </div>

<!--    data pathogen      v-show="dataPCRSpecLN.dataresultset_2[0].visible "     ---------------------------------------------------------------------------------------->
             
           <div class="container " v-if="dataPCRSpecLN.dataresultset_2.length>0">
               <TitlePlus :datUserWhoView="getNameAndSurname"
                          :titleDisplay="findingAndContent"
                          :plus=false
                          :showIcon = false
                          :showTitleDisplay = false
                          :visible = " dataPCRSpecLN.dataresultset_2[0].visible "
                           v-show="displayFooterAndTitleOrNot(dataPCRSpecLN.dataresultset_2[0].visible)"
                          />
            <div  class="container box" v-if="disPlayOrNot(dataPCRSpecLN,dataPCRSpecLN.dataresultset_2.length,dataPCRSpecLN.dataresultset_2[0].visible)">
                 
                <b-table             :data="dataPCRSpecLN.dataresultset_2"
                                     bordered
                                     narrowed
                                     hoverable
                                     focusable
                                     mobile-cards
                                     v-if="dataPCRSpecLN.dataresultset_2.length>0"  >
                    <b-table-column label="Pathogen" v-slot="props" width="50%">
                        {{ props.row.title }}  
                    </b-table-column>
                    <b-table-column label="Result" v-slot="props" width="25%">
                        <b> {{ props.row.result_dat }}</b>
                    </b-table-column>
                    <b-table-column label="Comment"       v-slot="props" width="25%">
                        {{ props.row.comment_each }} 
                    </b-table-column>
                </b-table>
            </div>

               <FooterPlus  :user_rec="dataPCRSpecLN.dataresultset_2[0].user_rec_fn"
                            :date_rec= "getISO8601ToYearMonthDate(dataPCRSpecLN.dataresultset_2[0].datetime_rec).date +'-' +getISO8601ToYearMonthDate(dataPCRSpecLN.dataresultset_2[0].datetime_rec).month +'-' +getISO8601ToYearMonthDate(dataPCRSpecLN.dataresultset_2[0].datetime_rec).year  "
                            :time_rec= "getISO8601ToYearMonthDate(dataPCRSpecLN.dataresultset_2[0].datetime_rec).hour +':' +getISO8601ToYearMonthDate(dataPCRSpecLN.dataresultset_2[0].datetime_rec).minute "
                            :user_delete="dataPCRSpecLN.dataresultset_2[0].user_edit"
                            :date_delete="dataPCRSpecLN.dataresultset_2[0].date_edit"
                            :time_delete="dataPCRSpecLN.dataresultset_2[0].time_edit"
                            :userIsAdmin="userIsAdmin"
                            :idToDelete = "dataPCRSpecLN.dataresultset_2[0].id.toString()"
                            :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.pcr_pathogen"
                            :labKind = "IDLABSelected.kind"
                            :canDelete ="dataPCRSpecLN.dataresultset_2[0].visible"
                            v-show="displayFooterAndTitleOrNot(dataPCRSpecLN.dataresultset_2[0].visible)"
                            @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
           </div>

  <!-- v-show="dataPCRSpecLN.dataresultset_2[0].visible " -->


<!--    data pathogen plus     ---------------------------------------------------------------------------------------->
           <div  class="container " v-if="dataPCRSpecLN.data_plus.dataresultset_2.length>0">
               <div v-for="data_pathogen_plus in dataPCRSpecLN.data_plus.dataresultset_2" :key="data_pathogen_plus.idtime">


                   <TitlePlus :datUserWhoView="getNameAndSurname"
                              :titleDisplay="findingAndContent"
                              :plus=false
                              :showIcon = false
                              :showTitleDisplay = false
                              :visible = " data_pathogen_plus.visible "
                              v-if=" data_pathogen_plus.visible "

                   />
                   <div  class="container box" v-if="disPlayOrNot(data_pathogen_plus,data_pathogen_plus.dat.length,data_pathogen_plus.visible)">
                        
                       <b-table             :data="data_pathogen_plus.dat"
                                            bordered
                                            narrowed
                                            hoverable
                                            focusable
                                            mobile-cards
                                            >
                           <b-table-column label="Pathogen" v-slot="props" width="50%">
                               {{ props.row.title }}
                           </b-table-column>
                           <b-table-column label="Result" v-slot="props" width="25%">
                               <b> {{ props.row.result_dat }}</b>
                           </b-table-column>
                           <b-table-column label="Remark"       v-slot="props"  width="25%">
                               {{ props.row.comment_each }}
                           </b-table-column>
                       </b-table>
                   </div>


                   <FooterPlus  :user_rec="data_pathogen_plus.dat[0].user_rec_fn"
                                :date_rec= "getISO8601ToYearMonthDate(data_pathogen_plus.dat[0].datetime_rec).date +'-' +getISO8601ToYearMonthDate(data_pathogen_plus.dat[0].datetime_rec).month +'-' +getISO8601ToYearMonthDate(data_pathogen_plus.dat[0].datetime_rec).year  "
                                :time_rec= "getISO8601ToYearMonthDate(data_pathogen_plus.dat[0].datetime_rec).hour +':' +getISO8601ToYearMonthDate(data_pathogen_plus.dat[0].datetime_rec).minute "
                                :user_delete="data_pathogen_plus.user_edit"
                                :date_delete="data_pathogen_plus.date_edit"
                                :time_delete="data_pathogen_plus.time_edit"
                                :userIsAdmin="userIsAdmin"
                                :idToDelete = "data_pathogen_plus.idtime.toString()"
                                :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.pcr_pathogen_plus"
                                :labKind = "IDLABSelected.kind"
                                :canDelete ="data_pathogen_plus.visible"
                                @footerPlusWithChangeDisable="footerPlusWithChangeDisable"
                                 v-if="disPlayOrNot(data_pathogen_plus,data_pathogen_plus.dat.length,data_pathogen_plus.visible)"
                                     />



               </div>


           </div>




            <br>





            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!-- Display Title if normal or plus existing  -->
<!--            <div class="container" v-if="dataPCRSpecLN.display_title_ct_for_nonadmin ">-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="findingAndContent"-->
<!--                           :plus=false-->
<!--                           :showIcon = true-->
<!--                           :showDatUserWhoView = "false"-->
<!--                           :showTitleDisplay = true-->
<!--                           :iconToShow = "iconFileDocument"-->
<!--                           :visible = "true"/>-->
<!--            </div>-->

            <div class="container" v-if=" displayTitle( dataPCRSpecLN.dat_ct.dat_txt , dataPCRSpecLN.data_plus.dat_ct , dataPCRSpecLN.display_title_ct_for_nonadmin )  ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="findingAndContent"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconFileDocument"
                           :visible = "true"/>
            </div>



            <!--     Findings and contents   -------------------------------------------------------------------------------------->
            <div class="container"  v-if="disPlayOrNot(dataPCRSpecLN ,dataPCRSpecLN.dat_ct.dat_txt.length ,dataPCRSpecLN.dat_ct.visible )" >
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="findingAndContent"
                           :plus=false
                           :showIcon = false
                           :showTitleDisplay = false
                           :visible = " dataPCRSpecLN.dat_ct.visible "/>
                <div class="box"  >
                    <div  v-html="getDecodeFromBase64ToHtml( dataPCRSpecLN.dat_ct.dat )"
                          :style= "getStyleVisibleFalseInContent(dataPCRSpecLN.dat_ct.visible)" >
                    </div>
                </div>

                <FooterPlus  :user_rec="dataPCRSpecLN.dat_ct.user_rec"

                             :date_rec= "getISO8601ToYearMonthDate(dataPCRSpecLN.dat_ct.datetime_rec).date +'-' +getISO8601ToYearMonthDate(dataPCRSpecLN.dat_ct.datetime_rec).month +'-' +getISO8601ToYearMonthDate(dataPCRSpecLN.dat_ct.datetime_rec).year  "
                             :time_rec= "getISO8601ToYearMonthDate(dataPCRSpecLN.dat_ct.datetime_rec).hour +':' +getISO8601ToYearMonthDate(dataPCRSpecLN.dat_ct.datetime_rec).minute "

                             :user_delete="dataPCRSpecLN.dat_ct.user_edit"
                             :date_delete="dataPCRSpecLN.dat_ct.date_edit"
                             :time_delete="dataPCRSpecLN.dat_ct.time_edit"
                             :userIsAdmin="userIsAdmin"
                             :idToDelete = "dataPCRSpecLN.dat_ct.id.toString()"
                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct"
                             :labKind = "IDLABSelected.kind"
                             :canDelete ="dataPCRSpecLN.dat_ct.visible"
                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
            </div>



            <!----------------------- Content Plus  -->
            <div v-for="dat_ct_plus in  dataPCRSpecLN.data_plus.dat_ct" :key="dat_ct_plus.id_uuid">
                <div  class="container" v-if="disPlayOrNot(true,true,dat_ct_plus.visible)">
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="headerPrepareInfoPlus"
                               :plus=true
                               :showIcon = false
                               :showTitleDisplay = false
                               :visible = " dat_ct_plus.visible "
                    />
                    <div class="box"  >
                        <div v-html="getDecodeFromBase64ToHtml(dat_ct_plus.dat)"  :style= "getStyleVisibleFalseInContent(dat_ct_plus.visible)" >
                        </div>
                    </div>
                    <FooterPlus  :user_rec="dat_ct_plus.user_rec"
                                 :date_rec="dat_ct_plus.date_rec"
                                 :time_rec="dat_ct_plus.time_rec"
                                 :user_delete="dat_ct_plus.user_edit"
                                 :date_delete="dat_ct_plus.date_edit"
                                 :time_delete="dat_ct_plus.time_edit"
                                 :canDelete ="dat_ct_plus.visible"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "dat_ct_plus.id.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"
                    />
                </div>
            </div>














            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!-- Display Title if normal or plus existing  -->
<!--            <div  class="container"  v-if="dataPCRSpecLN.display_title_image_for_nonadmin " >-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="images_title"-->
<!--                           :plus=false-->
<!--                           :showIcon = true-->
<!--                           :showDatUserWhoView = "false"-->
<!--                           :showTitleDisplay = true-->
<!--                           :iconToShow = "iconImage"-->
<!--                           :visible = "true"/>-->
<!--            </div>-->

            <div  class="container"  v-if="displayTitle( dataPCRSpecLN.img.dat , dataPCRSpecLN.data_plus.img , dataPCRSpecLN.display_title_image_for_nonadmin ) " >
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="images_title"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconImage"
                           :visible = "true"/>
            </div>
            <!----------------------  Images  ------>
            <template v-if="disPlayOrNot(dataPCRSpecLN ,dataPCRSpecLN.img.dat.length ,
                                         dataPCRSpecLN.img.dat.length>0 ? dataPCRSpecLN.img.dat[0].visible : false  )">
                <div class="container"  v-if="dataPCRSpecLN && dataPCRSpecLN.img.dat.length>0 " >
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="images_title"
                               :plus=false
                               :showDatUserWhoView = true
                               :showIcon = false
                               :showTitleDisplay = false
                    />



                    <ThumbnailImageList  v-if="dataPassThruImageList.length>0"
                                         :modeThumbnailImageList="modeThumbnailImageList"
                                         :dataPassThruImageList="dataPassThruImageList"
                                         :plus="false"/>


                    <FooterPlus  :user_rec="dataPCRSpecLN.img.user_rec"
                                 :date_rec="dataPCRSpecLN.img.date_rec"
                                 :time_rec="dataPCRSpecLN.img.time_rec"
                                 :user_delete="dataPCRSpecLN.img.user_edit"
                                 :date_delete="dataPCRSpecLN.img.date_edit"
                                 :time_delete="dataPCRSpecLN.img.time_edit"
                                 :canDelete ="dataPCRSpecLN.img.user_edit.length>0 ? false : true"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "IDLABSelected.idlab"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
                </div>

            </template>





            <!--           Image Plus  --------------------------------------------------------------------------------------------->
            <div  class="container"  v-for=" img in dataPCRSpecLN.data_plus.img" :key="img.idtime">
                <template v-if="disPlayOrNot(true,true,img.visible)">
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="ImagePlus"
                               :plus=true
                               :showIcon = false
                               :showTitleDisplay = false
                               :showDatUserWhoView = true
                    />
                    <br>
                    <ThumbnailImageList    :modeThumbnailImageList="modeThumbnailImageList" :dataPassThruImageList="dataPassThruImageListPlus(img.idtime)"  :plus="true"  />
                    <FooterPlus  :user_rec="getUserRecImgPlusByIdTime(img.idtime)"
                                 :date_rec="getDateRecImgPlusByIdTime(img.idtime)"
                                 :time_rec="getTimeRecImgPlusByIdTime(img.idtime)"
                                 :user_delete="img.user_edit.length>0 ? img.user_edit[0] : '' "
                                 :date_delete="img.date_edit.length>0 ? img.date_edit[0] : '' "
                                 :time_delete="img.time_edit.length>0 ? img.time_edit[0] : ''"
                                 :canDelete ="img.visible.length>0 ? img.visible[0] : false"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "img.idtime.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
                    <br>
                </template>
            </div>








            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!--  ***************************************************************************  -->
            <!-- Display Title if normal or plus existing  -->
<!--            <div  class="container" v-if="  dataPCRSpecLN.display_title_diag_for_nonadmin ">-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="ClassificationOfDiseases"-->
<!--                           :plus=false-->
<!--                           :showIcon = true-->
<!--                           :showDatUserWhoView = "false"-->
<!--                           :showTitleDisplay = true-->
<!--                           :iconToShow = "iconDx"-->
<!--                           :visible = "true"/>-->
<!--            </div>-->

            <div  class="container" v-if=" displayTitle( dataPCRSpecLN.diag_code.dat , dataPCRSpecLN.data_plus.diag_code ,  dataPCRSpecLN.display_title_diag_for_nonadmin) ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="ClassificationOfDiseases"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconDx"
                           :visible = "true"/>
            </div>


            <!----------------------  Diagosis  ---------------------------------------------------------------------------------->

            <template v-if="disPlayOrNot(dataPCRSpecLN ,dataPCRSpecLN.diag_code.dat.length ,
                                         dataPCRSpecLN.diag_code.dat.length>0 ? dataPCRSpecLN.diag_code.dat[0].visible : false  )">
                <div class="container"  v-if="dataPCRSpecLN && dataPCRSpecLN.diag_code.dat.length>0" >
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="ClassificationOfDiseases"
                               :plus=false
                               :showIcon = false
                               :showDatUserWhoView = "true"
                               :showTitleDisplay = false
                    />
                    <b-table             :data="isEmpty ? [] : dataPCRSpecLN.diag_code.dat "
                                         bordered
                                         striped
                                         narrowed
                                         hoverable
                                         focusable
                                         mobile-cards
                    >


                        <b-table-column field="level1Name" label="Chapter" v-slot="props">
                            {{ props.row.level1Name }}
                        </b-table-column>

                        <b-table-column field="level2Name" label="Body System" v-slot="props">
                            {{ props.row.level2Name }}
                        </b-table-column>

                        <b-table-column field="level3Name" label="Organ/Tissue" v-slot="props">
                            {{ props.row.level3Name }}
                        </b-table-column>

                        <b-table-column field="level4Name" label="Character/Subcategories" v-slot="props">
                            {{ props.row.level4Name }}
                        </b-table-column>

                        <b-table-column field="level5Name" label="Extensions" v-slot="props">
                            {{ props.row.level5Name }}
                        </b-table-column>


                        <b-table-column field="level5Name" label="Unclassified Descriptions" v-slot="props">
                            {{ props.row.unClassifiedCodes }}
                        </b-table-column>


                        <b-table-column field="level5Name" label="%" v-slot="props">
                            {{ props.row.labDiseasecodeAccurateName }}
                        </b-table-column>


                        <b-table-column field="level5Name" label="Remark"  v-slot="props">
                            {{ props.row.comment }}
                        </b-table-column>

                    </b-table>
                    <FooterPlus  :user_rec="dataPCRSpecLN.diag_code.user_rec"
                                 :date_rec="dataPCRSpecLN.diag_code.date_rec"
                                 :time_rec="dataPCRSpecLN.diag_code.time_rec"

                                 :user_delete="dataPCRSpecLN.diag_code.user_edit"
                                 :date_delete="dataPCRSpecLN.diag_code.date_edit"
                                 :time_delete="dataPCRSpecLN.diag_code.time_edit"
                                 :canDelete ="dataPCRSpecLN.diag_code.user_edit.length>0 ? false : true"

                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "IDLABSelected.idlab"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"/>
                    <br>
                </div>

            </template>




            <!----------------------         Diagosis Plus   dataCytoSpecLN.data_plus.diag_code  v-if="dataCytoSpecLN.data_plus.diag_code.length>0"-->
            <div  class="container"  v-for=" diag_code_plus in dataPCRSpecLN.data_plus.diag_code" :key="diag_code_plus.idtime">
                <template v-if="disPlayOrNot(true,true,diag_code_plus.visible)">



                    <TitlePlus
                            :datUserWhoView="getNameAndSurname"
                            :titleDisplay="ClassificationOfDiseases"
                            :plus=true
                            :showIcon = false
                            :showTitleDisplay = false
                            :showDatUserWhoView = true
                    />
                    <b-table         :data="diag_code_plus.dat"
                                     bordered
                                     striped
                                     narrowed
                                     hoverable
                                     focusable
                                     mobile-cards
                    >
                        <b-table-column   label="Chapter" v-slot="props">
                            {{ props.row.level1Name }}
                        </b-table-column>
                        <b-table-column   label="Body System" v-slot="props">
                            {{ props.row.level2Name }}
                        </b-table-column>
                        <b-table-column   label="Organ/Tissue" v-slot="props">
                            {{ props.row.level3Name }}
                        </b-table-column>
                        <b-table-column   label="Character/Subcategories" v-slot="props">
                            {{ props.row.level4Name }}
                        </b-table-column>
                        <b-table-column   label="Extensions" v-slot="props">
                            {{ props.row.level5Name }}
                        </b-table-column>
                        <b-table-column  label="Unclassified Descriptions" v-slot="props">
                            {{ props.row.unClassifiedCodes }}
                        </b-table-column>
                        <b-table-column  label="%" v-slot="props">
                            {{ props.row.labDiseasecodeAccurateName }}
                        </b-table-column>
                        <b-table-column  label="Remark" v-slot="props">
                            {{ props.row.comment }}
                        </b-table-column>

                    </b-table>
                    <FooterPlus  :user_rec="diag_code_plus.dat[0].user_rec"
                                 :date_rec="diag_code_plus.dat[0].date_rec"
                                 :time_rec="diag_code_plus.dat[0].time_rec"
                                 :user_delete="diag_code_plus.dat[0].user_edit.length>0 ? diag_code_plus.dat[0].user_edit : '' "
                                 :date_delete="diag_code_plus.dat[0].date_edit.length>0 ? diag_code_plus.dat[0].date_edit : '' "
                                 :time_delete="diag_code_plus.dat[0].time_edit.length>0 ? diag_code_plus.dat[0].time_edit : '' "
                                 :canDelete ="diag_code_plus.visible"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "diag_code_plus.idtime.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />

                </template>
            </div>


            <br>
            <!---------------- Display Title if normal or plus existing  -->
            <div  class="container"  v-if="  dataPCRSpecLN ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="RequestedInfo"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconInfoRequest"
                           :visible = "true"/>
            </div>
            <!-----------------     Request Info.  ----------------->
            <div class="container"  v-if="dataPCRSpecLN" >
                <TitlePlus
                        :datUserWhoView="getNameAndSurname"
                        :titleDisplay="RequestedInfo"
                        :plus=false
                        :showIcon = false
                        :showTitleDisplay = false
                        :showDatUserWhoView = true
                />
                <FooterRequest :dataReqToFooter="dataPCRSpecLN.data_req"/>
            </div>




            <!--   end of  >>>>>>   <div v-if="dataBACTSpecLN && dataBACTSpecLN.status.id >= 5 && dataBACTSpecLN.status.id <=6 ">          -->
        </div>

<!--        <div v-if="dataPCRSpecLN && dataPCRSpecLN.status.id >= 5 && dataPCRSpecLN.status.id <=6 ">-->

<!--&lt;!&ndash;     Prepare   &#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
<!--            <div class="container"  v-if="dataPCRSpecLN && dataPCRSpecLN.dat_prepare.dat_txt.length>0  " >-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="headerPrepareInfo"-->
<!--                           :plus=false />-->
<!--                <div class="box"  >-->
<!--                    <div v-html="getDecodeFromBase64ToHtml(dataPCRSpecLN.dat_prepare.dat)" ></div>-->
<!--                </div>-->
<!--                <FooterPlus  :user_rec="dataPCRSpecLN.dat_prepare.user_rec"-->
<!--                             :date_rec=" getISO8601ToYearMonthDate(dataPCRSpecLN.dat_prepare.datetime_rec).date +' ' +getISO8601ToYearMonthDate(dataPCRSpecLN.dat_prepare.datetime_rec).month +' ' +getISO8601ToYearMonthDate(dataPCRSpecLN.dat_prepare.datetime_rec).year  "-->
<!--                             :time_rec=" getISO8601ToYearMonthDate(dataPCRSpecLN.dat_prepare.datetime_rec).hour +':' + getISO8601ToYearMonthDate(dataPCRSpecLN.dat_prepare.datetime_rec).minute"-->
<!--                             :userIsAdmin="userIsAdmin"-->
<!--                             :idToDelete = "dataPCRSpecLN.dat_prepare.id.toString()"-->
<!--                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare"-->
<!--                             :labKind = "IDLABSelected.kind"-->
<!--                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />-->
<!--            </div>-->


<!--            <br>-->

<!--&lt;!&ndash;           Prepare Plus  &#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
<!--            <div class="container"  v-if="dataPCRSpecLN && dataPCRSpecLN.data_plus.dat_prepare.length>0" >-->
<!--                <div v-for="dat_prepare_plus in  dataPCRSpecLN.data_plus.dat_prepare" :key="dat_prepare_plus.id">-->
<!--                    <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                               :titleDisplay="headerPrepareInfoPlus"-->
<!--                               :plus=true />-->
<!--                    <div class="box"  >-->
<!--                        <div v-html="getDecodeFromBase64ToHtml(dat_prepare_plus.dat)" ></div>-->
<!--                    </div>-->
<!--                    <FooterPlus  :user_rec="dat_prepare_plus.user_rec"-->
<!--                                 :date_rec="dat_prepare_plus.date_rec"-->
<!--                                 :time_rec="dat_prepare_plus.time_rec"-->
<!--                                 :userIsAdmin="userIsAdmin"-->
<!--                                 :idToDelete = "dat_prepare_plus.id.toString()"-->
<!--                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare_plus"-->
<!--                                 :labKind = "IDLABSelected.kind"-->
<!--                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />-->

<!--                </div>-->
<!--            </div>-->


<!--&lt;!&ndash;          Main content Table UI for Result PCR  &ndash;&gt;-->
<!--            <div class="container "  v-if="dataPCRSpecLN && dataPCRSpecLN.dataresultset_2.length>0 " >-->

<!--                    <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                               :titleDisplay="resultPCRTitle"-->
<!--                               :plus=false />-->
<!--                    <div class="box">-->
<!--                    <b-table             :data="dataPCRSpecLN.dataresultset_2"-->
<!--                                         bordered-->

<!--                                         narrowed-->
<!--                                         hoverable-->
<!--                                         focusable-->
<!--                                         mobile-cards-->
<!--                                         v-if="dataPCRSpecLN.dataresultset_2.length>0"  >-->
<!--                        <b-table-column label="Pathogen" v-slot="props">-->
<!--                            {{ props.row.title }}-->
<!--                        </b-table-column>-->


<!--                        <b-table-column label="Result" v-slot="props">-->
<!--                           <b> {{ props.row.result_dat }}</b>-->
<!--                        </b-table-column>-->


<!--                        <b-table-column label="Remark"       v-slot="props">-->
<!--                            {{ props.row.comment_each }}-->
<!--                        </b-table-column>-->
<!--                    </b-table>-->
<!--                    </div>-->
<!--                    <FooterPlus  :user_rec="dataPCRSpecLN.dataresultset_2[0].user_rec_fn"-->
<!--                                 :date_rec=" getISO8601ToYearMonthDate(dataPCRSpecLN.dataresultset_2[0].datetime_rec).date +' ' +getISO8601ToYearMonthDate(dataPCRSpecLN.dataresultset_2[0].datetime_rec).month +' ' +getISO8601ToYearMonthDate(dataPCRSpecLN.dataresultset_2[0].datetime_rec).year  "-->
<!--                                 :time_rec=" getISO8601ToYearMonthDate(dataPCRSpecLN.dataresultset_2[0].datetime_rec).hour +':' + getISO8601ToYearMonthDate(dataPCRSpecLN.dataresultset_2[0].datetime_rec).minute"-->
<!--                                 :userIsAdmin="userIsAdmin"-->
<!--                                 :idToDelete = "IDLABSelected.idlab"-->
<!--                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.pcr_pathogen"-->
<!--                                 :labKind = "IDLABSelected.kind"-->
<!--                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"/>-->

<!--                <br>-->
<!--            </div>-->


<!--&lt;!&ndash;          Main content Table UI for Result PCR  PLUS   &#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
<!--            <div class="container "  v-if="dataPCRSpecLN && dataPCRSpecLN.data_plus.dataresultset_2.length>0 " >-->

<!--              <div  v-for="dataresultset_2 in dataPCRSpecLN.data_plus.dataresultset_2" :key="dataresultset_2.idtime">-->

<!--                        <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                                   :titleDisplay="resultPCRTitle"-->
<!--                                   :plus=true />-->
<!--                        <div class="box">-->
<!--                            <b-table             :data="dataresultset_2.dat"-->
<!--                                                 bordered-->
<!--                                                 narrowed-->
<!--                                                 hoverable-->
<!--                                                 focusable-->
<!--                                                 mobile-cards-->
<!--                                                   >-->
<!--                                <b-table-column label="Pathogen" v-slot="props">-->
<!--                                    {{ props.row.title }}-->
<!--                                </b-table-column>-->


<!--                                <b-table-column label="Result" v-slot="props">-->
<!--                                    <b> {{ props.row.result_dat }}</b>-->
<!--                                </b-table-column>-->


<!--                                <b-table-column label="Remark"       v-slot="props">-->
<!--                                    {{ props.row.comment_each }}-->
<!--                                </b-table-column>-->
<!--                            </b-table>-->
<!--                        </div>-->
<!--                        <FooterPlus  :user_rec="dataresultset_2.dat[0].user_rec_fn"-->
<!--                                     :date_rec=" getISO8601ToYearMonthDate(dataresultset_2.dat[0].datetime_rec).date +' ' +getISO8601ToYearMonthDate(dataresultset_2.dat[0].datetime_rec).month +' ' +getISO8601ToYearMonthDate(dataresultset_2.dat[0].datetime_rec).year  "-->
<!--                                     :time_rec=" getISO8601ToYearMonthDate(dataresultset_2.dat[0].datetime_rec).hour +':' + getISO8601ToYearMonthDate(dataresultset_2.dat[0].datetime_rec).minute"-->
<!--                                     :userIsAdmin="userIsAdmin"-->
<!--                                     :idToDelete = "dataresultset_2.idtime.toString()"-->
<!--                                     :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.pcr_pathogen_plus"-->
<!--                                     :labKind = "IDLABSelected.kind"-->
<!--                                     @footerPlusWithChangeDisable="footerPlusWithChangeDisable"/>-->
<!--              </div>-->
<!--             <br>-->
<!--            </div>-->




<!--&lt;!&ndash;     Findings and contents   &#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
<!--            <div class="container"  v-if="dataPCRSpecLN && dataPCRSpecLN.dat_ct.dat_txt.length>0  " >-->
<!--                    <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                               :titleDisplay="findingAndContent"-->
<!--                               :plus=false />-->
<!--                    <div class="box"  >-->
<!--                        <div v-html="getDecodeFromBase64ToHtml(dataPCRSpecLN.dat_ct.dat)" ></div>-->
<!--                    </div>-->
<!--                    <FooterPlus  :user_rec="dataPCRSpecLN.dat_ct.user_rec"-->
<!--                                 :date_rec=" getISO8601ToYearMonthDate(dataPCRSpecLN.dat_ct.datetime_rec).date +' ' +getISO8601ToYearMonthDate(dataPCRSpecLN.dat_ct.datetime_rec).month +' ' +getISO8601ToYearMonthDate(dataPCRSpecLN.dat_ct.datetime_rec).year  "-->
<!--                                 :time_rec=" getISO8601ToYearMonthDate(dataPCRSpecLN.dat_ct.datetime_rec).hour +':' + getISO8601ToYearMonthDate(dataPCRSpecLN.dat_ct.datetime_rec).minute"-->
<!--                                 :userIsAdmin="userIsAdmin"-->
<!--                                 :idToDelete = "dataPCRSpecLN.dat_ct.id.toString()"-->
<!--                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct"-->
<!--                                 :labKind = "IDLABSelected.kind"-->
<!--                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />-->
<!--            </div>-->
<!--    -->
<!--    -->
<!--&lt;!&ndash;           Content Plus      &#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
<!--            <div class="container"  v-if="dataPCRSpecLN !== null && dataPCRSpecLN.data_plus.dat_ct.length>0" >-->
<!--                <div v-for="dat_content_plus in  dataPCRSpecLN.data_plus.dat_ct" :key="dat_content_plus.id">-->
<!--                    <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                               :titleDisplay="findingAndContentPlus"-->
<!--                               :plus=true />-->
<!--                    <div class="box"  >-->
<!--                        <div v-html="getDecodeFromBase64ToHtml(dat_content_plus.dat)" ></div>-->
<!--                    </div>-->
<!--                    <FooterPlus  :user_rec="dat_content_plus.user_rec"-->
<!--                                 :date_rec="dat_content_plus.date_rec"-->
<!--                                 :time_rec="dat_content_plus.time_rec"-->
<!--                                 :userIsAdmin="userIsAdmin"-->
<!--                                 :idToDelete = "dat_content_plus.id.toString()"-->
<!--                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct_plus"-->
<!--                                 :labKind = "IDLABSelected.kind"-->
<!--                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />-->
<!--                </div>-->
<!--            </div>-->
<!--            -->
<!--            -->
<!--&lt;!&ndash;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;  Images  -&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
<!--           <div class="container"  v-if="dataPCRSpecLN && dataPCRSpecLN.img.dat.length>0" >-->
<!--                    <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                               :titleDisplay="images_title"-->
<!--                               :plus=false />-->
<!--                    <br>-->
<!--                    <ThumbnailImageList  v-if="dataPassThruImageList.length>0"-->
<!--                                         :modeThumbnailImageList="modeThumbnailImageList"-->
<!--                                         :dataPassThruImageList="dataPassThruImageList"-->
<!--                                         :plus="false"/>-->
<!--                    <FooterPlus  :user_rec="dataPCRSpecLN.img.user_rec"-->
<!--                                 :date_rec="dataPCRSpecLN.img.date_rec"-->
<!--                                 :time_rec="dataPCRSpecLN.img.time_rec"-->
<!--                                 :userIsAdmin="userIsAdmin"-->
<!--                                 :idToDelete = "IDLABSelected.idlab"-->
<!--                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images"-->
<!--                                 :labKind = "IDLABSelected.kind"-->
<!--                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />-->
<!--                    <hr>-->
<!--           </div>-->


<!--&lt;!&ndash;           Image Plus  -&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
<!--            <div class="container"  v-if="dataPCRSpecLN !== null && dataPCRSpecLN.data_plus.img.length>0" >-->
<!--                <div v-for=" img in dataPCRSpecLN.data_plus.img" :key="img.idtime">-->
<!--                    <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                               :titleDisplay="ImagePlus"-->
<!--                               :plus=true />-->
<!--                    <br>-->
<!--                    <ThumbnailImageList    :modeThumbnailImageList="modeThumbnailImageList" :dataPassThruImageList="dataPassThruImageListPlus(img.idtime)"  :plus="true"  />-->
<!--                    <FooterPlus  :user_rec="getUserRecImgPlusByIdTime(img.idtime)"-->
<!--                                 :date_rec="getDateRecImgPlusByIdTime(img.idtime)"-->
<!--                                 :time_rec="getTimeRecImgPlusByIdTime(img.idtime)"-->
<!--                                 :userIsAdmin="userIsAdmin"-->
<!--                                 :idToDelete = "img.idtime.toString()"-->
<!--                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images_plus"-->
<!--                                 :labKind = "IDLABSelected.kind"-->
<!--                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />-->
<!--                    <br>-->
<!--                </div>-->
<!--            </div>-->
<!--            <hr v-if="dataPCRSpecLN !== null && dataPCRSpecLN.img.dat.length>0">-->





<!-- &lt;!&ndash;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;  Diagosis  &#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->

<!--           <div class="container"  v-if="dataPCRSpecLN && dataPCRSpecLN.diag_code.dat.length>0" >-->
<!--                    <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                               :titleDisplay="ClassificationOfDiseases"-->
<!--                               :plus=false />-->
<!--                    <b-table             :data=" dataPCRSpecLN.diag_code.dat "-->
<!--                                         bordered-->
<!--                                         striped-->
<!--                                         narrowed-->
<!--                                         hoverable-->
<!--                                         focusable-->
<!--                                         mobile-cards-->
<!--                                         v-if="dataPCRSpecLN.diag_code.dat.length>0">-->


<!--                        <b-table-column field="level1Name" label="Chapter" v-slot="props">-->
<!--                            {{ props.row.level1Name }}-->
<!--                        </b-table-column>-->

<!--                        <b-table-column field="level2Name" label="Body System" v-slot="props">-->
<!--                            {{ props.row.level2Name }}-->
<!--                        </b-table-column>-->

<!--                        <b-table-column field="level3Name" label="Organ/Tissue" v-slot="props">-->
<!--                            {{ props.row.level3Name }}-->
<!--                        </b-table-column>-->

<!--                        <b-table-column field="level4Name" label="Character/Subcategories" v-slot="props">-->
<!--                            {{ props.row.level4Name }}-->
<!--                        </b-table-column>-->

<!--                        <b-table-column field="level5Name" label="Extensions" v-slot="props">-->
<!--                            {{ props.row.level5Name }}-->
<!--                        </b-table-column>-->


<!--                        <b-table-column field="level5Name" label="Unclassified Descriptions" v-slot="props">-->
<!--                            {{ props.row.unClassifiedCodes }}-->
<!--                        </b-table-column>-->


<!--                        <b-table-column field="level5Name" label="%" v-slot="props">-->
<!--                            {{ props.row.labDiseasecodeAccurateName }}-->
<!--                        </b-table-column>-->


<!--                        <b-table-column field="level5Name" label="Remark"  v-slot="props">-->
<!--                            {{ props.row.comment }}-->
<!--                        </b-table-column>-->






<!--                    </b-table>-->
<!--                    <FooterPlus  :user_rec="dataPCRSpecLN.diag_code.user_rec"-->
<!--                                 :date_rec="dataPCRSpecLN.diag_code.date_rec"-->
<!--                                 :time_rec="dataPCRSpecLN.diag_code.time_rec"-->
<!--                                 :userIsAdmin="userIsAdmin"-->
<!--                                 :idToDelete = "IDLABSelected.idlab"-->
<!--                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code"-->
<!--                                 :labKind = "IDLABSelected.kind"-->
<!--                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"/>-->
<!--                    <br>-->
<!--           </div>-->

<!--&lt;!&ndash;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;         Diagosis Plus   dataCytoSpecLN.data_plus.diag_code  v-if="dataCytoSpecLN.data_plus.diag_code.length>0"&ndash;&gt;-->
<!--            <div class="container" v-if="dataPCRSpecLN.data_plus.diag_code.length>0">-->

<!--                <div  v-for="diag_code_plus in dataPCRSpecLN.data_plus.diag_code" :key="diag_code_plus.idtime">-->

<!--                    <TitlePlus-->
<!--                            :datUserWhoView="getNameAndSurname"-->
<!--                            :titleDisplay="ClassificationOfDiseases"-->
<!--                            :plus=true-->
<!--                    />-->
<!--                    <b-table         :data="diag_code_plus.dat"-->
<!--                                     bordered-->
<!--                                     striped-->
<!--                                     narrowed-->
<!--                                     hoverable-->
<!--                                     focusable-->
<!--                                     mobile-cards-->
<!--                    >-->
<!--                        <b-table-column   label="Chapter" v-slot="props">-->
<!--                            {{ props.row.level1Name }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column   label="Body System" v-slot="props">-->
<!--                            {{ props.row.level2Name }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column   label="Organ/Tissue" v-slot="props">-->
<!--                            {{ props.row.level3Name }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column   label="Character/Subcategories" v-slot="props">-->
<!--                            {{ props.row.level4Name }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column   label="Extensions" v-slot="props">-->
<!--                            {{ props.row.level5Name }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column  label="Unclassified Descriptions" v-slot="props">-->
<!--                            {{ props.row.unClassifiedCodes }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column  label="%" v-slot="props">-->
<!--                            {{ props.row.labDiseasecodeAccurateName }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column  label="Remark" v-slot="props">-->
<!--                            {{ props.row.comment }}-->
<!--                        </b-table-column>-->

<!--                    </b-table>-->

<!--                    <FooterPlus  :user_rec="diag_code_plus.dat[0].user_rec"-->
<!--                                 :date_rec="diag_code_plus.dat[0].date_rec"-->
<!--                                 :time_rec="diag_code_plus.dat[0].time_rec"-->
<!--                                 :userIsAdmin="userIsAdmin"-->
<!--                                 :idToDelete = "diag_code_plus.idtime.toString()"-->
<!--                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code_plus"-->
<!--                                 :labKind = "IDLABSelected.kind"-->
<!--                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"/>-->
<!--                </div>-->
<!--            </div>-->



<!--&lt;!&ndash;            Request info  &ndash;&gt;-->
<!--            &lt;!&ndash;          Request info   &ndash;&gt;-->
<!--            <div class="container"  v-if="dataPCRSpecLN" >-->
<!--                <TitlePlus-->
<!--                        :datUserWhoView="getNameAndSurname"-->
<!--                        :titleDisplay="RequestedInfo"-->
<!--                        :plus=false-->
<!--                />-->
<!--                <div class="box">-->
<!--                <FooterRequest :dataReqToFooter="dataPCRSpecLN.data_req"/>-->
<!--                </div>-->
<!--            </div>-->
<!--       </div>-->







        <PlusEditor   v-if="isPlusEditor"
                      :isShowing="isPlusEditor"
                      :idlab="IDLABSelected.idlab"
                      :labKind="IDLABSelected.kind"
                      :submitTypePlusEdit="submitTypePlusEditTmp"
                      @close="closePlusEditor"
                      @closeWithChange="closePlusEditorWithChange" />


        <PlusImages  v-if="isPlusImages"
                     :isShowing="isPlusImages"
                     :idlab="IDLABSelected.idlab"
                     @closePlusImagesWithData="closePlusImagesWithData"
                     @closePlusImages="closePlusImages"/>


        <PlusSelectDiseaseCode v-if="isPlusSelectDiseaseCode"
                               :idlab="IDLABSelected.idlab"
                               :isShowing="isPlusSelectDiseaseCode"
                               @closePlusSelectDiseaseCode_WithChange = "closePlusSelectDiseaseCode_WithChange"
                               @closePlusSelectDiseaseCode="closePlusSelectDiseaseCode"/>
        <PlusPathogen  v-if="isPlusPathogen"
                       :idlab="IDLABSelected.idlab"
                       :isShowing="isPlusPathogen"
                       @closePlusPathoge_WithChange = "closePlusPathoge_WithChange"
                       @closePlusPathogen = "closePlusPathogen"/>

        <EditDocLabPCR
                ref="EditDocLabPCR"
                :isComponentModalActive="isPCREditorShowing"
                :IDLABSelected="IDLABSelected"
                @close="closeEditDocLabPCR"
        />


        <b-modal
                v-model="isSelectImgForMakePdf"
                has-modal-card
                full-screen
                :can-cancel="true">
            <SelectImgForMakePdf
                    :arrImg = "arrPropsToImgReport"
                    @closeSelectImgForMakePdfWithDataWantTo="doReqImageReportFile"
                    @closeSelectImgForMakePdf="closeSelectImgForMakePdf"/>
        </b-modal>



    </div>



</template>

<script>
    import {  genUUID , DATA_PCR_LN_MODEL ,getBaseURLAvartar } from '@/utils.js'
    import userRoleFind from "../../mixins/methods/userRoleFind";
    import globalconst from "../../mixins/globalconst";
    import getISO8601ToYearMonthDate from "../../mixins/methods/getISO8601ToYearMonthDate";
    import {mapState} from "vuex";
    import TitlePlus from "./Plus/TitlePlus";
    import ThumbnailImageList from "../UtilsComponents/ThumbnailImageList";
    import FooterPlus from "./Plus/FooterPlus";
    import FooterRequest from "./FooterRequest";
    import getDecodeFromBase64ToHtml from "../../mixins/methods/getDecodeFromBase64ToHtml";
    import PlusSelectDiseaseCode from "./Plus/PlusSelectDiseaseCode";
    import PlusImages from "./Plus/PlusImages";
    import PlusEditor from "./Plus/PlusEditor";
    import PlusPathogen from "./Plus/PlusPathogen";
    import EditDocLabPCR from "./EditDocLabPCR";
    import disPlayOrNot from "../../mixins/methods/disPlayOrNot";
    import iconTitle from "../../mixins/data/iconTitle";
    import getStyleVisibleFalseInContent from "../../mixins/methods/getStyleVisibleFalseInContent";
    import FileSaver from "file-saver";
    import doReportFile from "../../mixins/methods/doReportFile";
    import selectURL_NextFrom_DoReportFile_ByCallFrmVar from "../../mixins/methods/selectURL_NextFrom_DoReportFile_ByCallFrmVar";  
    import displayTitle from "../../mixins/methods/displayTitle";

    import SelectImgForMakePdf from "./SelectImgForMakePdf/SelectImgForMakePdf";

    export default {
        name: "PCR_EachID",
        components:{
            TitlePlus,
            ThumbnailImageList,
            FooterPlus,
            FooterRequest,
            PlusSelectDiseaseCode,
            PlusImages,
            PlusEditor,
            PlusPathogen,
            EditDocLabPCR,
            SelectImgForMakePdf
        },
        props:{
            dataPCRSpecLN : DATA_PCR_LN_MODEL,
            IDLABSelected: null ,
        },
        mixins:[globalconst,userRoleFind,getISO8601ToYearMonthDate,getDecodeFromBase64ToHtml,disPlayOrNot,iconTitle,getStyleVisibleFalseInContent,doReportFile,selectURL_NextFrom_DoReportFile_ByCallFrmVar,displayTitle],
        computed: {
            ...mapState({
                user_id: state => state.master_data.user_id,
                user_role: state => state.master_data.user_role,
                userIsAdmin:  state => state.master_data.userIsAdmin,
                clientIP: state => state.master_data.clientIP,
                access_token: state => state.master_data.access_token,
            }),
            getNameAndSurname: function(){
                const userFullName = localStorage.getItem('user_name_surname')

                return  `<p class="has-text-weight-light has-text-grey-lighter" style="color: #00b89c; padding-top: 15px">
                         View by ${userFullName}
                          ${this.getISO8601ToYearMonthDate(this.dataPCRSpecLN.current_datetime).date}
                          ${this.getISO8601ToYearMonthDate(this.dataPCRSpecLN.current_datetime).month}
                          ${this.getISO8601ToYearMonthDate(this.dataPCRSpecLN.current_datetime).year}
                          <i>
                          (
                          ${this.getISO8601ToYearMonthDate(this.dataPCRSpecLN.current_datetime).hour}
                          :
                          ${this.getISO8601ToYearMonthDate(this.dataPCRSpecLN.current_datetime).minute}
                          )
                          </i>
                          </p>`
                // return localStorage.getItem('user_name_surname')
            },
            dataPassThruImageList: function () {
                // [ { id: tmpID ,
                //     file : null,
                //     urlTempUploaded: tmpUrl,
                //     title : vm.dataAllContent.img.dat[i].title,
                //     fileNameUploaded:  vm.dataAllContent.img.dat[i].file ,
                //     fresh : false  } ]
                if(this.dataPCRSpecLN.img.dat.length>0) {
                    return this.dataPCRSpecLN.img.dat.map(dat => {
                        return {
                            id: genUUID(5),
                            file: null,
                            urlTempUploaded: `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}`,
                            title: dat.title,
                            fileNameUploaded: dat.file,
                            fresh: false
                        }
                    })
                }else{
                    return []
                }
            }
        },
        methods:{

            displayFooterAndTitleOrNot(_dataVisible){
                if(this.userIsAdmin){
                    return true
                }
                return  _dataVisible
            },
            closeSelectImgForMakePdf(){
                this.isSelectImgForMakePdf = false
            },

            reqImageReportFile(){
                if  (this.dataPCRSpecLN.display_title_image_for_nonadmin){
                    // build arr
                    // {"id":1  , "descp": "lorem","select": true,"url": "http://127.0.0.1:5000/static/uploads/64BIOP0000000155/179452040286.jpg"}
                    // `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}`,
                    this.arrPropsToImgReport = []
                    //genUUID
                    this.dataPCRSpecLN.img.dat.forEach(dat=>{
                        if (dat.visible){
                            this.arrPropsToImgReport.push(   {"id":genUUID(5)  , "descp": "", "select": false,"url": `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}` , "file": dat.file }  )
                        }
                    })
                    //
                    for(var i =0 ; i<this.dataPCRSpecLN.data_plus.img.length;i++){
                        for(var j =0; j < this.dataPCRSpecLN.data_plus.img[i].visible.length ; j++){
                            if (this.dataPCRSpecLN.data_plus.img[i].visible[j]){
                                this.arrPropsToImgReport.push(
                                    {"id":genUUID(5)  , "descp": "", "select": false,
                                        "url": `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${this.dataPCRSpecLN.data_plus.img[i].file[j]}` ,
                                        "file": this.dataPCRSpecLN.data_plus.img[i].file[j]
                                    }
                                )
                            }
                        }

                    }


                    if ( this.arrPropsToImgReport.length >0 ){
                        this.isSelectImgForMakePdf = true
                    }else{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `Nothing Images`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    }



                }

            },


            doReqImageReportFile(payload){
                this.isSelectImgForMakePdf = false
                var arr_img_data_want = []
                for(var i=0;i<payload.arrImg.length;i++){
                    if (payload.arrImg[i].select){
                        arr_img_data_want.push(payload.arrImg[i].file)
                    }
                }


                this.reqReportFile(true,parseInt( payload.num_of_col ) ,arr_img_data_want)


            },

            reqReportFile(pure_Img,col_if_pure_img,arr_img_data_want){
                if(pure_Img){
                    this.loadingImgReportFile = true
                }else{
                    this.loadingReportFile = true
                }

                this.doReportFile(this.IDLABSelected,this.clientIP,pure_Img,col_if_pure_img,arr_img_data_want)
                    .then(res=>{
                        FileSaver.saveAs(this.selectURL_NextFrom_DoReportFile_ByCallFrmVar(res), `${res.file_name}.pdf`);
                        if(pure_Img){
                            this.loadingImgReportFile = false
                        }else{
                            this.loadingReportFile = false
                        }
                    })
                    .catch(err=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.response.data.msg}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        if(pure_Img){
                            this.loadingImgReportFile = false
                        }else{
                            this.loadingReportFile = false
                        }
                    })
                    .finally(()=>{
                        if(pure_Img){
                            this.loadingImgReportFile = false
                        }else{
                            this.loadingReportFile = false
                        }
                    })
            },











            closeEditDocLabPCR(){
                // this.$refs.EditDocLabPCR.isComponentModalActive = false
                this.isPCREditorShowing = false
            },
            showEditPCR(){

                // this.$refs.EditDocLabPCR.loadOldDat()
                // this.$refs.EditDocLabPCR.isComponentModalActive = true
                //
                this.isPCREditorShowing = true

            },

            closePlusEditor(){
                this.isPlusEditor = false
            },
            closePlusEditorWithChange(){
                this.$emit('trigForPlusUpdate')
                this.isPlusEditor = false
            },
            closePlusImagesWithData(){
                this.isPlusImages = false
                this.$emit('trigForPlusUpdate')
            },
            closePlusImages(){
                this.isPlusImages = false
            },
            showPlusImages(){
                this.isPlusImages = true
            },
            closePlusSelectDiseaseCode(){
                this.isPlusSelectDiseaseCode = false
            },
            closePlusSelectDiseaseCode_WithChange(){
                // console.log('closePlusSelectDiseaseCode_WithChange')
                this.$emit('trigForPlusUpdate')
                this.isPlusSelectDiseaseCode = false
            },
            addPlusSelectDiseaseCode(){
                this.isPlusSelectDiseaseCode = true
            },
            showPlusEditor(_type){
                this.submitTypePlusEditTmp = _type
                this.isPlusEditor = true
            },

            closePlusPathoge_WithChange(){
                this.isPlusPathogen = false
                this.$emit('trigForPlusUpdate')
            },
            closePlusPathogen(){
                this.isPlusPathogen = false
            },
            addPlusPathogen(){
                this.isPlusPathogen = true
            },






            plusSomething(){
                if(this.plusSomethingSelected === null){
                    this.hasErrorPlusSomethingSelected = true
                    return
                }


                if(this.plusSomethingSelected  == 0){
                    this.showPlusEditor(this.SUBMIT_TYPE_PLUS_EDIT.prepare)
                }else if (this.plusSomethingSelected  == 1){
                    this.showPlusEditor(this.SUBMIT_TYPE_PLUS_EDIT.ct)
                }else if (this.plusSomethingSelected  == 2){
                    this.showPlusImages()
                }else if (this.plusSomethingSelected  == 3){
                    this.addPlusSelectDiseaseCode()
                }else if (this.plusSomethingSelected  == 4){
                    this.addPlusPathogen()
                }else {
                    return
                }
            },
            footerPlusWithChangeDisable(){
                this.$emit('trigForPlusUpdate')
            },


            getTimeRecImgPlusByIdTime(_idtime){
                const member  = this.dataPCRSpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.time_rec[0]
            },
            getDateRecImgPlusByIdTime(_idtime){
                const member  = this.dataPCRSpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.date_rec[0]
            },
            getUserRecImgPlusByIdTime(_idtime){
                const member  = this.dataPCRSpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.user_rec[0]
            },
            dataPassThruImageListPlus(_idtime) {
                if(this.dataPCRSpecLN.data_plus.img.length>0) {
                    const member = this.dataPCRSpecLN.data_plus.img.find(data => data.idtime === _idtime)
                    var tmpArr = []
                    for (var i = 0; i <= member.id.length - 1; i++) {
                        const tmp = {
                            id: member.id[i],
                            file: null,
                            urlTempUploaded: `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${member.file[i]}`,
                            title: member.title[i],
                            fileNameUploaded: member.file[i],
                            fresh: false
                        }
                        tmpArr.push(tmp)
                    }
                    return tmpArr
                }else{
                    return []
                }
            }



        },
        data(){
            return {
                hasErrorPlusSomethingSelected : false ,
                plusSomethingSelected : null,

                modeThumbnailImageList : "view",
                submitTypePlusEditTmp : "",
                isPlusSelectDiseaseCode : false,
                isPlusImages : false,
                isPlusEditor : false,
                isPlusPathogen : false,


                isPCREditorShowing : false,
                isEmpty : false,


                isSelectImgForMakePdf : false,
                arrPropsToImgReport : []
            }
        },
        watch:{
            plusSomethingSelected :{
                immediate : true,
                handler : function (val) {
                    if(val !== null){
                        this.hasErrorPlusSomethingSelected = false
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>